module.exports = __webpack_public_path__ + "static/img/active-button.203281e3.png";